module.exports = __webpack_public_path__ + "static/media/img_marathon_S.ef9dce8f.svg";